// extracted by mini-css-extract-plugin
export default {"table":"CurrencyInfo_table__5xbT3","tableHeading":"CurrencyInfo_tableHeading__RQU6K","chart":"CurrencyInfo_chart__f6DLZ"};